/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axios from 'axios';
import utils from './utils';

const API_ADMIN = `${utils.svcUrl()}admin`;

const API_NOTIFICATION = `${utils.svcUrl()}notifications`;

export default {
  getTopics: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_ADMIN}/topics`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  getSources: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${API_ADMIN}/feeds`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  },
  checkSite: (url) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/getSite`, { url })
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  },
  submitMemberRequest: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_ADMIN}/apply-request`, data)
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  },
  sendDM: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_NOTIFICATION}/sendDM`, data)
        .then((result) => resolve(result.data))
        .catch((error) => reject(error));
    });
  },
};
